/**
 * An error boundary that should display a refresh help page. And submit a bug report.
 */

import styled from "@emotion/styled";
import { isProd } from "config/env";

export interface SomethingWentWrongProps {
  error: Error | null;
  stack: string | null;
}

export const SomethingWentWrong: React.FC<SomethingWentWrongProps> = ({ error, stack }) => {
  return (
    <Container>
      <h1>Something went wrong</h1>
      <p>Sorry, something went wrong. Please try refreshing the page.</p>

      {!isProd ? (
        <div>
          <pre> {error ? JSON.stringify(error) : `Odd - there was no error caught.`} </pre>
          <pre> {stack ? stack : `Odd - there was no stack caught.`} </pre>
        </div>
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  background-color: #000;
  color: #fff;
  margin: 0 auto;
`;
